import { render, staticRenderFns } from "./PickUpEform.vue?vue&type=template&id=b06b2c6c&scoped=true"
import script from "./PickUpEform.vue?vue&type=script&lang=js"
export * from "./PickUpEform.vue?vue&type=script&lang=js"
import style0 from "./PickUpEform.vue?vue&type=style&index=0&id=b06b2c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06b2c6c",
  null
  
)

export default component.exports